import React, { useState, useEffect } from "react";
import { PaginationTable } from "@nike/epic-react-ui";

export default function FilterableTable({ columns, data, fields }) {
  const [filteredTableData, setFilteredTableData] = useState(data);
  const [filters, setFilters] = useState([]);
  const [currentFilters, setCurrentFilters] = useState({});
  const isCompact = true;
  const pageSizeOptions = [10, 25, 50];

  useEffect(() => {
    if (data !== filteredTableData) {
      setFilteredTableData(data);
      onFiltersChange(currentFilters);
    }
  }, [data]);

  useEffect(() => {
    var generatedFilters = [];
    for (var field of fields) {
      var valueFilters = [];
      var newFilter = {
        name: field,
        accessor: field,
        filters: []
      };
      for (var entry of data) {
        if (!valueFilters.includes(entry[field])) {
          newFilter.filters.push({
            name: entry[field],
            accessor: entry[field]
          });
          valueFilters.push(entry[field]);
        }
      }
      generatedFilters.push(newFilter);
    }
    setFilters(generatedFilters);
    //console.log(generatedFilters);
  }, [data, fields]);

  const onFiltersChange = filterState => {
    setCurrentFilters(filterState);
    var filteredData = [];
    for (var entry of data) {
      var matchCount = 0;
      var emptyFilters = true;
      var filterCount = 0;
      for (var activeFilter in filterState) {
        if (filterState[activeFilter].length !== 0) {
          filterCount += 1;
          emptyFilters = false;
          if (filterState[activeFilter].includes(entry[activeFilter])) {
            //console.log(entry);
            matchCount += 1;
          }
        }
      }
      if (matchCount === filterCount) {
        //console.log(entry);
        filteredData.push(entry);
      }
    }
    if (emptyFilters) {
      setFilteredTableData(data);
    } else {
      setFilteredTableData(filteredData);
    }
  };
  /* eslint-disable */
  return (
    <div>
      <PaginationTable
        {...{
          isCompact,
          columns,
          data: filteredTableData,
          filters,
          onFiltersChange,
          pageSizeOptions
        }}
      />
    </div>
  );
  /* eslint-enable */
}
